module.exports = __webpack_public_path__ + "static/media/i-Like.3667cb39.mp3";